import React from 'react';

import { Link } from 'components/Link/Link';
import { Permission } from 'generated/graphql';
import { useVenueContext } from 'routes/Main';
import styles from './ChangeCta.module.scss';
import { getEnvironmentVariables } from '../../services/environment-variables/environment-variables';

const ChangeCta: React.FC = () => {
  const { currentUser, currentVenue: venue } = useVenueContext();
  const { SUPPORT_FORM_URL } = getEnvironmentVariables();
  const canEditItem = currentUser?.permissions?.includes(Permission.PublishMenu);
  if (!venue) return null;
  const formUrl = new URL(SUPPORT_FORM_URL);
  formUrl.searchParams.set('support_category', 'Menu Issues');
  formUrl.searchParams.set('content', 'Insert your query here...\n\n');
  formUrl.searchParams.set('venue_name', `${venue.name} (${venue.hashedId})`);
  return (
    <div className={styles.Outer} data-testid="change-cta-container">
      <strong data-testid="change-cta-copy">Need {canEditItem ? `help with your` : `changes to this`} menu?</strong>
      <p>
        <Link openNewTab showExternalIcon href={formUrl.href}>
          Contact our support team
        </Link>
      </p>
    </div>
  );
};

export default ChangeCta;
